import axios from 'axios';
import { API_URL } from '../config';
import { APPLICATION_CONTRACT_TYPES } from '../constants';
import { mobileApiInstance } from '../axios/mobileApiInstance';

const ax = axios.create();

export const getContractPdfRequest = async (type, token) => {
  switch (type) {
    case APPLICATION_CONTRACT_TYPES.ROAD_CARE:
      return mobileApiInstance.get(`/contracts/${type}/pdf/${token}`).then((response) => response.data);
    default:
      return axios.get(`${API_URL}/contract-by-token/${type}/${token}`).then((response) => response.data);
  }
};

export const sendPDFSToEmailsRequest = async (id, data) => {
  const { type } = data;

  switch (type) {
    case APPLICATION_CONTRACT_TYPES.ROAD_CARE:
      return mobileApiInstance.post(`/contracts/${id}/send-pdf`, data).then((response) => response.data);
    default:
      return axios.post(`${API_URL}/pdf/${id}/send`, data).then((response) => response.data);
  }
};

export const getRecurringPaymentsSummary = async (data) => {
  const URL = `${API_URL}/pdf/validation`;
  return ax.post(URL, data).then((response) => response.data);
};
